import PropTypes from 'prop-types';
import React from 'react';

import { SideBar, ResultsPanel } from '../../styles';

const CalculatorLayout = ({ sidebar, results }) => (
  <div style={{ display: 'grid', gridTemplateColumns: 'minmax(320px, 420px) 1fr', gap: 24 }}>
    <SideBar style={{ display: 'grid', gap: 16 }}>{sidebar}</SideBar>
    <ResultsPanel>{results}</ResultsPanel>
  </div>
);

CalculatorLayout.propTypes = {
  sidebar: PropTypes.node.isRequired,
  results: PropTypes.node.isRequired,
};

export default CalculatorLayout;
